import React from 'react';
import { Lock } from 'lucide-react';

// Card borrado de "recurso bloqueado", usado para deixar um recurso pago sempre visível
// (nunca escondido do menu/UI) mas comunicando com clareza qual plano libera ele.
const PaywallCard = ({ titulo, descricao, plano = 'Comum', className = '' }) => {
  return (
    <div className={`relative rounded-[28px] border border-purple-50 bg-[#F8F7FF] p-6 flex flex-col items-center justify-center overflow-hidden min-h-[250px] ${className}`}>
      <div className="absolute inset-0 bg-white/60 backdrop-blur-[2px] z-10 flex flex-col items-center justify-center p-4 text-center">
        <span className="flex items-center gap-1 text-[10px] font-black uppercase bg-amber-100 text-amber-700 px-3 py-1 rounded-md mb-2 shadow-sm">
          <Lock size={12} /> Plano {plano}
        </span>
        <p className="text-sm font-black text-slate-800 m-0 mt-1">{titulo}</p>
        {descricao && (
          <p className="text-[10px] text-slate-500 font-semibold mt-1">{descricao}</p>
        )}
      </div>
      <div className="opacity-30 flex items-center justify-between w-full max-w-[200px] border-2 border-dashed border-purple-100 p-4 rounded-xl">
        <div className="w-10 h-10 bg-slate-300 rounded-full"></div>
        <div className="flex-1 ml-3 h-4 bg-slate-300 rounded-md"></div>
      </div>
    </div>
  );
};

export default PaywallCard;
